<template>
  <div
    class="absolute bottom-0 w-full bg-white p-6 sm:w-[inherit] md:p-8 md:pl-12"
  >
    <slot />
  </div>
</template>
